import { RouteObject } from "react-router-dom";
import {
  MANAGE_SELLERS_AND_STORES,
  MANAGE_SELLERS_AND_STORES_OVERVIEW,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_BESTSELLER,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_DETAIL,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_ORDER,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_PAYMENT,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_BESTSELLER,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_DETAIL,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_ORDER,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_PAYMENT,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PROMOTION,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_DETAIL,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_PAYMENT,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PAYMENT_DETAIL,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_APPROVAL,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_ORDER_DETAIL,
  MANAGE_SELLERS_AND_STORES_TRANSACTION_DETAIL,
  MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_BESTSELLER,
  MANAGE_SELLERS_AND_STORES_TAXONOMY,
} from "constants/urls";

export default [
  {
    path: MANAGE_SELLERS_AND_STORES,
    lazy: () => import("./routes/ManageSellerAndStoreLinkList"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW,
    lazy: () => import("./routes/ManageSellerAndStoreOverview"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewProducts"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_DETAIL,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewProductsDetail"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_ORDER,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewProductOrders"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_ORDER_DETAIL,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewProductOrderDetail"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_BESTSELLER,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewProductBestSeller"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PRODUCT_PAYMENT,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewProductPayment"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewServices"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_DETAIL,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewServicesDetail"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_ORDER,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewServiceOrders"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_BESTSELLER,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewServiceBestSeller"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_SERVICE_PAYMENT,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewServicePayment"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewVendors"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_BESTSELLER,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewVendorBestSeller"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_DETAIL,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewVendorsDetail"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_APPROVAL,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewVendorsApproval"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_VENDOR_PAYMENT,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewVendorsPayment"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PAYMENT_DETAIL,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewPaymentDetail"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_TRANSACTION_DETAIL,
    lazy: () => import("./routes/ManageSellerAndStoreTransactionDetail"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_OVERVIEW_PROMOTION,
    lazy: () => import("./routes/ManageSellerAndStoreOverviewPromotion"),
  },
  {
    path: MANAGE_SELLERS_AND_STORES_TAXONOMY,
    lazy: () => import("./routes/ManageSellerAndStoreTaxonomy"),
  },
] as RouteObject[];
